import React from 'react';

export const CheckIcon = (props) => {
  return (
    <svg fill='none' viewBox='0 0 30 30' height='1em' width='1em' {...props}>
      <g
        id='icon/checked/grey'
        stroke='none'
        strokeWidth='1'
        fill='currentColor'
        fillRule='evenodd'
      >
        <path
          d='M22.6390625,6.7015625 C23.4168446,5.96108595 24.6415735,5.97035282 25.4080616,6.72251405 C26.1745497,7.47467527 26.2069209,8.69901132 25.48125,9.490625 L14.8828125,22.7453125 C14.5145829,23.1419298 14.0008383,23.3716662 13.4597303,23.3816867 C12.9186223,23.3917072 12.3967241,23.1811494 12.0140625,22.7984375 L4.985625,15.77 C4.45264,15.2733594 4.23324436,14.5253993 4.41350715,13.8195451 C4.59376995,13.1136908 5.14494083,12.5625199 5.85079509,12.3822572 C6.55664934,12.2019944 7.3046094,12.42139 7.80125,12.954375 L13.3634375,18.5139063 L22.5885937,6.76 C22.6052029,6.73954922 22.6229388,6.72003981 22.6417187,6.7015625 L22.6390625,6.7015625 Z'
          id='Path'
          fill='currentColor'
          fillRule='nonzero'
        ></path>
      </g>
    </svg>
  );
};
